export default "__VITE_ASSET__BVp_tu7u__"